import { render, staticRenderFns } from "./SubheaderBlog.vue?vue&type=template&id=22f383a2"
import script from "./SubheaderBlog.vue?vue&type=script&lang=js"
export * from "./SubheaderBlog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports